import { GOOD, MUTED, SOFT_BORDER, TEXT, WARNING } from "../shared/styles";

const GRAU = "#9ca3af";

function getDataQualityMeta(score) {
  const isUnavailable =
    score === null ||
    score === undefined ||
    Number.isNaN(score);

  if (isUnavailable) {
    return {
      pct: 0,
      displayValue: "-",
      label: "Nicht verfügbar",
      color: GRAU
    };
  }

  const pct = score;

  if (pct === 100) return { pct, displayValue: `${pct}%`, label: "Verifiziert", color: GOOD };
  if (pct >= 67) return { pct, displayValue: `${pct}%`, label: "Plausibel", color: WARNING };
  if (pct >= 34) return { pct, displayValue: `${pct}%`, label: "Geschätzt", color: WARNING };

  return { pct, displayValue: `${pct}%`, label: "Basisschätzung", color: GRAU };
}

export default function DataQualityBadge({ score }) {
  const { pct, displayValue, label, color } = getDataQualityMeta(score);
  const size = 52;
  const strokeWidth = 6;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference * (1 - pct / 100);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "0.6rem"
      }}
    >
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ flexShrink: 0 }}>
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke={SOFT_BORDER} strokeWidth={strokeWidth} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          style={{ transition: "stroke-dashoffset 0.4s ease" }}
        />
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          dominantBaseline="central"
          fontSize="0.72rem"
          fontWeight="700"
          fontFamily="inherit"
          fill={TEXT}
        >
          {displayValue}
        </text>
      </svg>
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: "0.7rem", color: MUTED, fontWeight: 700 }}>Datenqualitätsscore</div>
        <div style={{ color, fontSize: "0.85rem", fontWeight: 700 }}>{label}</div>
      </div>
    </div>
  );
}
